import { BaseApi } from "@/api/BaseApi";
import Config from "@/const/Config";
import { EnableQrReq, LoginQr, LoginQrReq } from '@/types/Qr'

export class QrApi extends BaseApi {
  /**
   * ログイン情報が記載されたQRコードのダウンロード
   */
  public async getLoginQr(req: LoginQrReq): Promise<LoginQr> {
    try {
      const res = await this.post<LoginQr>(Config.API_URL + "/qr/publish", req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * QRが有効かチェックする
   */
  public async isEnableToken(req: EnableQrReq): Promise<Boolean> {
    try {
      const res = await this.post<Boolean>(Config.API_URL + "/qr/is_enable_token", req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }
}
